const schema = {
  version: 1,
  name: "Select location",
  slug: null,
  address: "Select location",
  mapsLink: "",
  reviewLink: "",
  phone: {
    primary: "",
    sms: "",
  },
  messenger: "",
  email: {
    manager: "",
    frontDesk: "",
  },
  social: [],
}

export default schema
